import { Inject, Pipe, PipeTransform } from '@angular/core';
import { DocType } from '../enums/doc-type.enum';
import { DocTypePipe } from './doc-type.pipe';
import { DocumentSearch } from '@xpo-ltl/sdk-documentmanagement';
import moment from 'moment-timezone';
const moment2 = moment;

@Pipe({
  name: 'documentSearchPipe',
})
export class DocumentSearchPipe implements PipeTransform {
  constructor(private docTypePipe: DocTypePipe) {}

  transform(value: DocumentSearch): any {
    if (!value) {
      return undefined;
    }
    return `${this.docTypePipe.transform(<DocType>value.cdt.docClass)} - ${moment2(value.timestampISO).format(
      'MM/DD/YYYY hh:mm'
    )}`;
  }
}
